module.exports = __webpack_public_path__ + "files/ffcde3682a62ff9e10368e14481429ac.png";